module.exports = __webpack_public_path__ + "img/background034.1e0f809b.jpg";